export const dedupeArray = <T>(array: T[]) => Array.from(new Set(array));
